import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import styles from './name-kana-field.module.css';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function NameKanaField() {
  return (
    <div className={companyRegistrationPageStyles.nameField}>
      <div className={styles.container}>
        <FormField.Root name='contactPersonInfo.firstNameKana'>
          <label>
            <span>セイ</span>
            <Body />
          </label>

          <FormField.Error />
        </FormField.Root>
      </div>

      <div className={styles.container}>
        <FormField.Root name='contactPersonInfo.lastNameKana'>
          <label>
            <span>メイ</span>
            <Body />
          </label>

          <FormField.Error />
        </FormField.Root>
      </div>
    </div>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return <InputTextV2 required className={styles.input} {...fieldProps} />;
}
